var d = new Date();
var currYear = d.getFullYear();
export default function Footer() {
  return (
    <footer style={{ background: "#111", color: "#fff", padding: 20 }}>
      <div className="container">
        <p>© {currYear}  Trishikha RO Sales & Services</p>
      </div>
    </footer>
  );
}